import styled from 'styled-components';

export const StyledFNMSCookieRefreshIframe = styled.iframe`
	position: absolute;
	width: 0px;
	height: 0px;
	border: 0px;
	visibility: hidden;
`;
